// frontend/src/themes/palettes/galaxia.js
import { sharedComponents } from "./shared";
export default {
  muiMode: "dark",
  scrollbarColor: "#5C55A6",
  palette: {
    primary:    { main: "#9D7BFF" },
    secondary:  { main: "#4FC3F7" },
    background: { default: "#0B0E23", paper: "#151A38" },
    text:       { primary: "#E4E6F5", secondary: "#9BA0C8" },
    divider:    "rgba(157,123,255,0.16)",
    action:     { hover: "rgba(255,255,255,0.05)", selected: "rgba(157,123,255,0.14)" },
  },
  components: {
    ...sharedComponents,
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 6, backgroundColor: "#1B2148" },
        notchedOutline: { borderColor: "rgba(157,123,255,0.35)" },
        input: { color: "#E4E6F5", "&::placeholder": { color: "#6B70A0", opacity: 1 } },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: { color: "#E4E6F5", "&::placeholder": { color: "#6B70A0", opacity: 1 } },
      },
    },
    MuiFormLabel: { styleOverrides: { root: { color: "#9BA0C8" } } },
  },
  custom: {
    chat: {
      sentBg: "#2A2F5E", sentText: "#E4E6F5",
      receivedBg: "#1B2044", receivedText: "#E4E6F5",
      quotedSentBg: "#353B70", quotedReceivedBg: "#232858", accent: "#9D7BFF", contactAccent: "#4FC3F7",
    },
    chartPalette: ["#9D7BFF", "#4FC3F7", "#FF6EC7", "#FFD54F", "#69F0AE", "#B39DDB"],
    login: { bg: "#0B0E23" },
    decorId: "galaxia",
  },
};
